export default __webpack_public_path__ + "static/background-sp-01a9db5cb320887dc73ea504519ce16f.png";